export default "__VITE_ASSET__Cuef6v5N__"